import { Box } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";

export interface SpacerProps {
  hDesktop: string;
  hMobile: string;
  hTablet: string;
}

const Spacer = ({ hDesktop, hMobile, hTablet, sbEditable }: SbEditableComponentProps<SpacerProps>) => {
  const margin = hTablet === "auto" || hMobile === "auto" || hDesktop === "auto" ? "auto" : 0;
  return <Box h={{ base: hMobile, md: hTablet, xl: hDesktop }} my={margin} {...sbEditable} />;
};

export default Spacer;
